import { useCallback, useEffect, useState } from "react";
import {
  createAccount,
  loadTeamProfiles,
  setProfileRole,
  type CreateAccountPayload,
} from "@/store/api";
import type { Role, TeamMember } from "@/types";

// Carga y administra todas las cuentas del equipo (administradores y asesores).
export const useTeam = () => {
  const [members, setMembers] = useState<TeamMember[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const list = await loadTeamProfiles();
      setMembers(list);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : "No se pudo cargar el equipo.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const changeRole = useCallback(async (id: string, role: Role) => {
    const saved = await setProfileRole(id, role);
    setMembers((prev) => prev.map((m) => (m.id === saved.id ? saved : m)));
  }, []);

  const create = useCallback(
    async (payload: CreateAccountPayload) => {
      await createAccount(payload);
      await refresh();
    },
    [refresh]
  );

  return { members, loading, error, refresh, changeRole, create };
};